export default "__VITE_ASSET__0RkFgt1I__";